import { NgModule } from "@angular/core";
import { F3MediaWatcherService } from "./media-watcher.service";

@NgModule({
    providers: [
        F3MediaWatcherService
    ]
})
export class F3MediaWatcherModule {

    /**
     * Constructor
     * @param _f3MediaWatcherService 
     */
    constructor(
        private _f3MediaWatcherService: F3MediaWatcherService
    ) { }

}